// @flow
import React from 'react';

import {
  LIVE,
  TO_COME,
  OVER,
  DEFAULT_OPTIONS
} from 'components/competitionsInternationales/competitionsInternationalesMatchsResults';
import SingleMatchCard from 'components/competitionsInternationales/SingleMatchCard';
import type { Rencontre } from 'types/competitionsInternationales';

type Props = {
  allMatchs: Rencontre[],
  equipeNom: string,
  filter: DEFAULT_OPTIONS
};

function CompetitionsInternationalesMatchsResultsTournament({ allMatchs, equipeNom, filter }: Props) {
  // pour que le match soit live il faut qu'il ne soit pas terminée / pas de tri à appliquer car devrait être seule
  const liveMatch = allMatchs.filter(match => match.rencontre_live === true && match.rencontre_terminee === false);

  // les matchs à venir ont rencontre_live et rencontre_terminee à false
  const matchToCome = allMatchs.filter(match => match.rencontre_live === false && match.rencontre_terminee === false);

  // les matchs terminé ont rencontre_terminee à true
  const matchOver = allMatchs.filter(match => match.rencontre_terminee === true);

  const equipeName = equipeNom ?? '';
  let displayedMatches = 0;
  filter.forEach(value => {
    if (value === LIVE) {
      displayedMatches += liveMatch.length;
    } else if (value === TO_COME) {
      displayedMatches += matchToCome.length;
    } else if (value === OVER) {
      displayedMatches += matchOver.length;
    }
  });

  return (
    <>
      {filter.has(LIVE) &&
        liveMatch.map(match => <SingleMatchCard key={match.id} rencontre={match} equipeNom={equipeName} />)}

      {filter.has(TO_COME) &&
        matchToCome.map(match => <SingleMatchCard key={match.id} rencontre={match} equipeNom={equipeName} />)}

      {filter.has(OVER) &&
        matchOver.map(match => <SingleMatchCard key={match.id} rencontre={match} equipeNom={equipeName} />)}

      {displayedMatches === 0 && <p className="empty-state">Aucun match ne correspond à vos filtres</p>}
    </>
  );
}

export default CompetitionsInternationalesMatchsResultsTournament;
